import { HTMLCustomElement } from '@emartech/ui-framework-utils';

export class PersonalizationProductSourceSelectorDialog extends HTMLCustomElement {
  static elementName = 'pp-product-source-selector-dialog';

  init() {
    this._state = {
      headline: 'Product source selector'
    };
  }

  static get observedAttributes() {
    return ['headline'];
  }

  set headline(value) {
    this._state.headline = value;
  }

  openDialog(formData) {
    this.identifier = `pp-vce-product-source-selector-${PersonalizationProductSourceSelectorDialog.counter}`;
    this.innerHTML = `<div id="${this.identifier}"></div>`;
    this.getImportedApps()
      .then(app => app.renderProductSourceDialog(`#${this.identifier}`))
      .then(app => app.$children[0])
      .then(vm => {
        vm.setHeadline(this._state.headline);
        vm.openDialog(formData);
        this._forwardCustomEvent(vm, 'apply');
        this._forwardCustomEvent(vm, 'remove');
      });
  }

  getImportedApps() {
    if (!this.appLoaded) {
      this.appLoaded = import('../../apps/product-source-dialog');
    }

    return this.appLoaded;
  }

  _forwardCustomEvent(productSourceSelectorDialog, eventName) {
    productSourceSelectorDialog.$on(eventName, detail => {
      this.dispatchEvent(new CustomEvent(eventName, { detail }));
    });
  }
}

PersonalizationProductSourceSelectorDialog.counter = 0;
